import { render, staticRenderFns } from "./ProgressDetails.vue?vue&type=template&id=50c1e07d&"
import script from "./ProgressDetails.vue?vue&type=script&lang=js&"
export * from "./ProgressDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports